import VueBaseController from '../vue_base'

export class IndexController extends VueBaseController {
  static get COMPONENT() {
    return () => import('@/vue/pages/admin/permission_groups/index.vue')
  }
}

export class NewController extends VueBaseController {
  static get COMPONENT() {
    return () => import('@/vue/pages/admin/permission_groups/edit.vue')
  }
}

export class EditController extends VueBaseController {
  static get COMPONENT() {
    return () => import('@/vue/pages/admin/permission_groups/edit.vue')
  }

  static values = {
    groupId: String
  }

  connect() {
    super.connect({
      groupId: this.groupIdValue
    })
  }
}
